import React, { Component } from "react";
import Dialog from 'material-ui/Dialog';
import { inject, observer } from 'mobx-react';
import { withRouter, Link } from 'react-router-dom';
import _ from "lodash";
import validate from 'validate.js';

import { PageWrapper } from "components/PageWrapper";
import QuestionForm from "../components/QuestionForm";

import {QUESTION_CONSTRAINS} from 'constants/adminPupups';
import HttpClient from 'services/HttpClient';

const MCQ_QUESTIONS_API = '/api/v1/mcq_questions';
const MCQ_THEMES_API = '/api/v1/themes';

@withRouter
@inject('mcqThemesStore')
@inject('mcqQuestionsStore')
@inject('alertStore')
@observer
class EditQuestion extends Component {
  constructor() {
    super();

    this.state = {
      isConfirmModalOpened: false,
    };
  }

  componentDidMount() {
    const { mcqQuestionsStore, mcqThemesStore, match } = this.props;
    const id = match.params.id;

    mcqQuestionsStore.clearQuestion();

    new HttpClient().get(`${MCQ_QUESTIONS_API}/${id}`)
    .then(({ body }) => {
      const { question } = body.data || {};
      const { themes, options } = question || {};
      const theme_ids = themes.map(theme => theme.id);
      const optionsParsed = options.map(option => JSON.parse((option || '').replaceAll('=>', ':')));
      const clearedQuestion = _.assign(body.data.question, {
        theme_ids,
        options: optionsParsed,
      })
      mcqQuestionsStore.setQuestion(clearedQuestion);
    });
    new HttpClient().get(MCQ_THEMES_API)
    .then(({ body }) => {
      mcqThemesStore.setMcqThemes(body.data.theme);
    });
  };

  validationProcess = question => {
    let errors = validate(question, QUESTION_CONSTRAINS, { fullMessages: false });

    return errors
  };

  onSubmit = () => {
    const { mcqQuestionsStore, alertStore, history, match, mcqThemesStore: { mcq_themes } } = this.props;
    const id = match.params.id;
    const ids = mcq_themes.map(theme => theme.id);
    const theme_ids = mcqQuestionsStore.question.theme_ids;
    const question = _.assign({id}, mcqQuestionsStore.question, {
      theme_ids: theme_ids.length === 0 ? ids : theme_ids,
    });
    const errors = this.validationProcess(question);

    if (errors) return;

    new HttpClient().put(`${MCQ_QUESTIONS_API}/${question.id}`, {mcq_question: question})
    .then(data => {
      alertStore.success('You successfully edited question');
      history.push('/mcq-questions');
    });
  };

  deleteQuestion = () => {
    const { alertStore, history, match } = this.props;
    const id = match.params.id;

    new HttpClient().delete(`${MCQ_QUESTIONS_API}/${id}`)
    .then(() => {
      alertStore.success('You successfully delete question');
      history.push('/mcq-questions');
    });
  };

  handleOpenConfirmModal = () => {
    this.setState({
      isConfirmModalOpened: true,
    });
  };

  handleCloseConfirmModal = () => {
    this.setState({
      isConfirmModalOpened: false,
    });
  };

  render() {
    const { isConfirmModalOpened } = this.state;

    return (
      <PageWrapper>
        <Dialog
          className="modal-wrapper category-handle"
          title='Are you sure you want to delete this question?'
          modal={true}
          open={isConfirmModalOpened}
          customContentStyle={{
            height: '100%',
            maxHeight: 'none',
          }}
          bodyClassName="modal-content"
          repositionOnUpdate={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={false}>
          <div className="button-set">
            <button
              className="btn gray small transparanted cancel-btn"
              type="reset"
              onClick={this.handleCloseConfirmModal}
            >
              No
            </button>
            <button
              className="btn gray small transparanted apply-btn"
              type="submit"
              onClick={this.deleteQuestion}
            >
              Yes
            </button>
          </div>
        </Dialog>
        <div className="page-container">
          <h2>Edit MCQ Question</h2>
        </div>
        <button onClick={this.handleOpenConfirmModal} className='delete-btn'>delete question</button>
        <div className="row">
          <div className="container">
            <QuestionForm />
            <div className="submit-btns-container">
              <Link className='btn-new-main' to='/mcq-questions'>cancel</Link>
              <button className='btn-new-main' onClick={this.onSubmit}>edit question</button>
            </div>
          </div>
        </div>
      </PageWrapper>
    );
  }
};

export default EditQuestion;



// WEBPACK FOOTER //
// ./src/modules/admin/mcqQuestions/containers/EditQuestion.js